import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="22" height="20" viewBox="0 0 22 20" fill="#F1281B" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11 0l3.168 6.64 7.294.96-5.336 5.066 1.34 7.233L11 16.39 4.534 19.9l1.34-7.234L.538 7.6l7.294-.962L11 0z" /></svg>);